import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    marginTop: "1vh",
    flexDirection: "row",
  },
  box: {
    backgroundColor: "$option_card",
    borderRadius: 2,
    padding: "1.5vmin",
    paddingBottom: 0,
    margin: "1vmin",
    alignItems: "center",
    borderWidth: 3,
    borderColor: "$option_card",
  },
  selectedBox: {
    borderColor: "$selected_option",
  },
  image: {
    width: "12vmin",
    height: "12vmin",
  },
  label: {
    fontSize: "$gender_label_size",
    fontFamily: "$gender_label_style",
    marginTop: "2vh",
    color: "$option_text",
    textTransform: "uppercase",
  },
});
